import React from 'react';
import { Box, Container, SimpleGrid, Link, Image, Text, Flex, IconButton } from '@chakra-ui/react';
import { FaFacebookF, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import googleappEn from '../assets/images/Google_Play_Store_badge_EN.png'
import googleappFn from '../assets/images/Google_Play_Store_badge_FR.png'
import appleappEn from '../assets/images/app_store_badge_EN.png'
import appleappFn from '../assets/images/app_store_badge_FR.png'

const Footer = () => {
    const { t, i18n } = useTranslation();
    return (
        <Box bg="white" color="gray.600" pt={8} pb={4} mt={10}>
            {/* Section: Social media */}
            <Container maxW="container.xl" centerContent marginY="30px">
                <SimpleGrid columns={[1, 1, 3]} spacing={4} alignItems="center">
                    {/* Left Image */}
                    <Box display="flex" justifyContent="center">
                        <Image
                            src="https://kiido-media.s3.eu-west-3.amazonaws.com/Frame+7326_left.png"
                            alt="Left Image"
                            maxW="full"
                            objectFit="contain"
                        />
                    </Box>

                    {/* App Store & Play Store Buttons */}
                    <Box display="flex" justifyContent="center" alignItems="center" gap={4}>
                        <Link href="https://apps.apple.com/fr/app/kiido/id6444884424?itsct=apps_box_badge&amp;itscg=30200" isExternal>
                            <Image
                                src={i18n.language === 'fr' ? appleappFn : appleappEn}
                                alt="Download on the App Store"
                                // width="150px"    
                                height="50px"
                            />
                        </Link>
                        <Link href="https://play.google.com/store/apps/details?id=fr.kiido.kiido" isExternal>
                            <Image
                                src={i18n.language === 'fr' ? googleappFn : googleappEn}
                                alt="Get it on Google Play"
                                // width="150px"
                                height="50px"
                            />
                        </Link>
                    </Box>

                    {/* Right Image */}
                    <Box display="flex" justifyContent="center">
                        <Image
                            src="https://kiido-media.s3.eu-west-3.amazonaws.com/Frame+7327_right.png"
                            alt="Right Image"
                            maxW="full"
                            objectFit="contain"
                        />
                    </Box>
                </SimpleGrid>
            </Container>

            {/* Section: Links */}
            <Container maxW="container.xl" centerContent pt={8}>

                <Box display="flex" alignItems="center" flexWrap="wrap" textAlign="center" flexDirection={{ base: "column", sm: "row" }}>
                    <Link href="https://kiido.fr/knowledge" paddingX={3} textTransform="capitalize" fontWeight="normal" fontSize="18px" color="#818181" _hover={{
                        color: "#FF6666",
                        textDecoration: "none"
                    }}>
                        {t("faq")}
                    </Link>
                    {/* 
                        <Link href="/connect" textTransform="uppercase" fontWeight="bold">
                            Collaborators
                        </Link>
                        <Link href="/enterprises" textTransform="uppercase" fontWeight="bold">
                            Enterprises
                        </Link> */}
                    <Link href={`https://kiido.fr/disclaimer?topic=privacy-policy&locale=${i18n.language === 'fr' ? 'fr' : 'en'}`} paddingX={3} textTransform="capitalize" fontWeight="normal" fontSize="18px" color="#818181" _hover={{
                        color: "#FF6666",
                        textDecoration: "none"
                    }}>
                        {t("privacy_policy")}
                    </Link>
                    <Link href={`https://kiido.fr/disclaimer?topic=terms-of-use&locale=${i18n.language === 'fr' ? 'fr' : 'en'}`} paddingX={3} textTransform="capitalize" fontWeight="normal" fontSize="18px" color="#818181" _hover={{
                        color: "#FF6666",
                        textDecoration: "none"
                    }}>
                        {t("terms_of_services")}
                    </Link>
                </Box>

            </Container>

            {/* Section: Logo & Social Links */}
            <Container maxW="container.xl" centerContent pt={8} mb={7}>
                <Box textAlign="center" display="flex" flexDirection="column" alignItems="center" >
                    <a href='https://kiido.fr/'>
                        <Image
                            src="https://kiido.fr/static/Kiido_Logo_Originallogo.svg"
                            alt="Kiido Logo"
                            maxW="125px"
                            mb={0}
                        />
                    </a>
                    <Text fontSize="12px" color="gray.500" mb={8}>
                        © 2024 KIIDO, SAS.
                    </Text>

                    {/* Social Media Icons */}
                    <Flex justify="center" gap={4}>
                        <IconButton
                            as="a"
                            href="https://www.facebook.com/kiidoapp/"
                            target="_blank"
                            aria-label="Facebook"
                            icon={
                                <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M32.0246 0H5.72711C3.04799 0 0.876038 2.17186 0.876038 4.85107V31.1488C0.876038 33.828 3.0479 35.9998 5.72711 35.9998H18.6969L18.719 23.1354H15.3769C14.9425 23.1354 14.59 22.7842 14.5883 22.3499L14.5723 18.2032C14.5706 17.7665 14.9242 17.4115 15.3609 17.4115H18.697V13.4048C18.697 8.75492 21.5368 6.22304 25.6848 6.22304H29.0885C29.524 6.22304 29.8771 6.57609 29.8771 7.01166V10.5082C29.8771 10.9436 29.5243 11.2966 29.089 11.2968L27.0001 11.2978C24.7444 11.2978 24.3075 12.3697 24.3075 13.9428V17.4116H29.2643C29.7366 17.4116 30.103 17.824 30.0474 18.2931L29.5559 22.4398C29.5089 22.8366 29.1724 23.1356 28.7728 23.1356H24.3297L24.3075 36H32.0248C34.7039 36 36.8758 33.8281 36.8758 31.149V4.85107C36.8757 2.17186 34.7038 0 32.0246 0Z"
                                        fill="#FF6666" />
                                </svg>
                            }
                        />
                        <IconButton
                            as="a"
                            href="https://www.linkedin.com/company/kiidoapp/?viewAsMember=truetrue"
                            target="_blank"
                            aria-label="LinkedIn"
                            icon={
                                <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M31.9668 0H5.78495C4.48297 0 3.23433 0.517206 2.31369 1.43784C1.39306 2.35847 0.875854 3.60712 0.875854 4.90909L0.875854 31.0909C0.875854 32.3929 1.39306 33.6415 2.31369 34.5622C3.23433 35.4828 4.48297 36 5.78495 36H31.9668C33.2687 36 34.5174 35.4828 35.438 34.5622C36.3587 33.6415 36.8759 32.3929 36.8759 31.0909V4.90909C36.8759 3.60712 36.3587 2.35847 35.438 1.43784C34.5174 0.517206 33.2687 0 31.9668 0ZM13.1486 28.4891C13.1489 28.5889 13.1294 28.6878 13.0914 28.7801C13.0534 28.8724 12.9975 28.9563 12.927 29.027C12.8565 29.0977 12.7728 29.1538 12.6806 29.192C12.5884 29.2303 12.4895 29.25 12.3897 29.25H9.15585C9.05585 29.2503 8.95679 29.2308 8.86435 29.1926C8.77191 29.1545 8.68792 29.0984 8.61721 29.0277C8.5465 28.957 8.49046 28.873 8.45232 28.7806C8.41417 28.6882 8.39468 28.5891 8.39495 28.4891V14.9318C8.39495 14.73 8.47511 14.5365 8.61781 14.3938C8.76051 14.2511 8.95405 14.1709 9.15585 14.1709H12.3897C12.5912 14.1715 12.7842 14.2519 12.9264 14.3945C13.0687 14.5371 13.1486 14.7304 13.1486 14.9318V28.4891ZM10.7718 12.8864C10.1649 12.8864 9.57173 12.7064 9.06717 12.3693C8.56261 12.0321 8.16936 11.553 7.93713 10.9923C7.70491 10.4317 7.64415 9.81478 7.76254 9.21961C7.88092 8.62444 8.17314 8.07774 8.60223 7.64865C9.03132 7.21956 9.57802 6.92734 10.1732 6.80895C10.7684 6.69057 11.3853 6.75133 11.9459 6.98355C12.5065 7.21578 12.9857 7.60903 13.3229 8.11359C13.66 8.61815 13.8399 9.21135 13.8399 9.81818C13.8399 10.6319 13.5167 11.4123 12.9413 11.9877C12.3659 12.5631 11.5855 12.8864 10.7718 12.8864ZM30.0522 28.5423C30.0525 28.6342 30.0346 28.7253 29.9995 28.8103C29.9645 28.8953 29.9129 28.9725 29.8479 29.0375C29.7829 29.1025 29.7057 29.1541 29.6207 29.1891C29.5357 29.2242 29.4446 29.2421 29.3527 29.2418H25.8754C25.7835 29.2421 25.6924 29.2242 25.6074 29.1891C25.5224 29.1541 25.4452 29.1025 25.3801 29.0375C25.3151 28.9725 25.2636 28.8953 25.2286 28.8103C25.1935 28.7253 25.1756 28.6342 25.1759 28.5423V22.1911C25.1759 21.242 25.454 18.0348 22.6947 18.0348C20.5572 18.0348 20.1215 20.2295 20.0356 21.2155V28.5505C20.0356 28.7342 19.9634 28.9106 19.8344 29.0415C19.7054 29.1724 19.5301 29.2473 19.3463 29.25H15.9877C15.8959 29.25 15.805 29.2319 15.7203 29.1967C15.6355 29.1615 15.5585 29.11 15.4937 29.045C15.4289 28.98 15.3776 28.9029 15.3427 28.818C15.3077 28.7331 15.2899 28.6422 15.2902 28.5505V14.8725C15.2899 14.7807 15.3077 14.6898 15.3427 14.6049C15.3776 14.5201 15.4289 14.443 15.4937 14.378C15.5585 14.313 15.6355 14.2614 15.7203 14.2262C15.805 14.1911 15.8959 14.173 15.9877 14.173H19.3463C19.5318 14.173 19.7098 14.2467 19.841 14.3778C19.9722 14.509 20.0459 14.687 20.0459 14.8725V16.0548C20.8395 14.8623 22.0156 13.9459 24.5254 13.9459C30.0849 13.9459 30.0481 19.1373 30.0481 21.9886L30.0522 28.5423Z"
                                        fill="#FF6666" />
                                </svg>
                            }
                        />
                        <IconButton
                            as="a"
                            href="https://www.instagram.com/kiido_app/"
                            target="_blank"
                            aria-label="instagram"
                            icon={<svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_27454_746)">
                                    <path
                                        d="M27.3134 6.39844H10.4384C8.69373 6.39844 7.27429 7.81787 7.27429 9.5625V26.4375C7.27429 28.1821 8.69373 29.6016 10.4384 29.6016H27.3134C29.058 29.6016 30.4774 28.1821 30.4774 26.4375V9.5625C30.4774 7.81787 29.058 6.39844 27.3134 6.39844ZM18.8759 25.3828C14.8054 25.3828 11.493 22.0704 11.493 18C11.493 13.9296 14.8054 10.6172 18.8759 10.6172C22.9463 10.6172 26.2587 13.9296 26.2587 18C26.2587 22.0704 22.9463 25.3828 18.8759 25.3828ZM26.2587 12.7266C25.0958 12.7266 24.1493 11.7801 24.1493 10.6172C24.1493 9.45428 25.0958 8.50781 26.2587 8.50781C27.4216 8.50781 28.368 9.45428 28.368 10.6172C28.368 11.7801 27.4216 12.7266 26.2587 12.7266Z"
                                        fill="#FF6666" />
                                    <path
                                        d="M18.8759 12.7266C15.9683 12.7266 13.6024 15.0925 13.6024 18C13.6024 20.9075 15.9683 23.2734 18.8759 23.2734C21.7834 23.2734 24.1493 20.9075 24.1493 18C24.1493 15.0925 21.7834 12.7266 18.8759 12.7266Z"
                                        fill="#FF6666" />
                                    <path
                                        d="M31.5321 0H6.2196C3.31207 0 0.875854 2.43622 0.875854 5.34375V30.6562C0.875854 33.5638 3.31207 36 6.2196 36H31.5321C34.4396 36 36.8759 33.5638 36.8759 30.6562V5.34375C36.8759 2.43622 34.4396 0 31.5321 0ZM32.5868 26.4375C32.5868 29.345 30.2209 31.7109 27.3134 31.7109H10.4384C7.53082 31.7109 5.16492 29.345 5.16492 26.4375V9.5625C5.16492 6.65497 7.53082 4.28906 10.4384 4.28906H27.3134C30.2209 4.28906 32.5868 6.65497 32.5868 9.5625V26.4375Z"
                                        fill="#FF6666" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_27454_746">
                                        <rect width="36" height="36" fill="white" transform="translate(0.875854)" />
                                    </clipPath>
                                </defs>
                            </svg>}

                        />
                    </Flex>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
